export default __webpack_public_path__ + "static/element_different-4effe602828028695333bf085e4b787e.png";